import { Box, FormControlLabel, Pagination, Paper, Stack, Switch } from "@mui/material";
import { useSnackbar } from "notistack";
import React from "react";
import { getCancelChargeList } from "../../Api/Adjustment";
import { ApiError } from "../../Api/ApiError";
import { CancelCharge } from "../../Objects/CancelCharge";
import { StoreObjectStore } from "../../ObjectStore/StoreObjectStore";
import CategoryTitle from "../atoms/CategoryTitle";
import CancelChargeCard from "../molecules/CancelChargeCard";

const StoreDetailCancel: React.FC = () => {
    let { enqueueSnackbar } = useSnackbar()
    let { storeObjectState } = React.useContext(StoreObjectStore)

    const [cancelChargeList, setCancelChargeList] = React.useState<CancelCharge[]>()
    const [limit] = React.useState<number>(20)
    const [page, setPage] = React.useState<number>(1)
    const [isAddSettled, setIsAddSettled] = React.useState<boolean>(false)
    const [rows, setRows] = React.useState<number>()

    React.useEffect(() => {
        const controller = new AbortController()
        if (storeObjectState.storeData?.str_id) {
            getCancelChargeList({
                str_id: storeObjectState.storeData.str_id,
                show_page: page,
                limit: limit,
                is_add_settled: isAddSettled
            }, {signal: controller.signal}).then(result => {
                setCancelChargeList(result.list)
                setRows(result.rows)
            }).catch((e: any) => {
                if( e.__CANCEL__ ) {
                    console.info("canceled")
                } else if (e instanceof ApiError) {
                    enqueueSnackbar(e.message, { variant: "error" })
                } else if (e instanceof Error) {
                    enqueueSnackbar(e.message, { variant: "error" })
                }else {
                    enqueueSnackbar("通信に失敗しました", { variant: "error" })
                }
            })
        }
        return () => {
            controller.abort()
        }
    }, [storeObjectState.storeData?.str_id, limit, page, isAddSettled, enqueueSnackbar])

    return (
        <Paper sx={{ mt: 2, pb: 2 }}>
            <CategoryTitle
                text="キャンセル料管理"
            />
            <Box sx={{
                padding: "10px",
                display: "flex",
                justifyContent: "center",
            }}>
                <Pagination
                    count={rows ? Math.ceil(rows / limit) : 1}
                    page={page}
                    variant="outlined"
                    onChange={(e, page) => {
                        setPage(page)
                    }}
                />
            </Box>
            <Stack
                spacing={1}
                sx={{
                    p: 2,
                    width: 600,
                    maxWidth: "100%",
                    mx: "auto"
                }}
            >
                <FormControlLabel
                    control={<Switch
                        checked={isAddSettled}
                        onChange={(e) => {
                            setIsAddSettled(e.target.checked)
                            setPage(1)
                        }}
                    />}
                    label="支払済みのキャンセル料も表示する"
                />
                {cancelChargeList && cancelChargeList.map(cancelCharge => (
                    <CancelChargeCard
                        cancelCharge={cancelCharge}
                        key={cancelCharge.adjdtl_id}
                    />
                ))}
            </Stack>
            <Box sx={{
                padding: "10px",
                display: "flex",
                justifyContent: "center",
            }}>
                <Pagination
                    count={rows ? Math.ceil(rows / limit) : 1}
                    page={page}
                    variant="outlined"
                    onChange={(e, page) => {
                        setPage(page)
                    }}
                />
            </Box>
        </Paper>
    );
}

export default StoreDetailCancel